(function () {
  if (customElements.get('bunitta-bag-upsell')) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ERROR_TEXT = 'De shopping bag kon niet worden toegevoegd. Probeer het opnieuw.';

  class BunittaBagUpsell extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-bag-upsell-add]');
      this.errorEl = this.querySelector('[data-bag-upsell-error]');
      if (!this.button || this._bound) return;
      this._bound = true;
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        this.add();
      });
    }

    setBusy(busy) {
      this.busy = busy;
      this.button.disabled = busy;
      this.button.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    getSections(drawer) {
      if (drawer) return ['cart-drawer', 'cart-icon-bubble'];
      var items = document.getElementById('main-cart-items');
      var footer = document.getElementById('main-cart-footer');
      return [items && items.dataset.id, footer && footer.dataset.id, 'cart-icon-bubble'].filter(Boolean);
    }

    async add() {
      // Dubbelklik-bescherming: per blok en globaal.
      if (this.busy || window.__bunittaBagAdding) return;
      window.__bunittaBagAdding = true;
      this.setBusy(true);
      if (this.errorEl) this.errorEl.hidden = true;

      var variantId = Number(this.dataset.variantId);
      var drawer = this.closest('cart-drawer');
      var sections = this.getSections(drawer);

      try {
        // Extra controle: zit de tas er al in, dan niets toevoegen.
        var cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
        var alreadyInCart = (cart.items || []).some(function (item) {
          return item.variant_id === variantId;
        });
        if (alreadyInCart) {
          window.location.reload();
          return;
        }

        var response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: sections,
            sections_url: window.location.pathname
          })
        });
        var data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'add failed');

        this.render(data, drawer);
      } catch (error) {
        console.error('[bunitta-bag-upsell]', error);
        this.showError(ERROR_TEXT);
        this.setBusy(false);
      } finally {
        window.__bunittaBagAdding = false;
      }
    }

    render(data, drawer) {
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
        return;
      }

      var sections = data.sections || {};
      var replaced = 0;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');

        if (id === 'cart-icon-bubble') {
          var bubble = document.getElementById('cart-icon-bubble');
          var bubbleSource = doc.querySelector('.shopify-section');
          if (bubble && bubbleSource) bubble.innerHTML = bubbleSource.innerHTML;
          return;
        }

        var target = document.getElementById('shopify-section-' + id);
        var source = doc.getElementById('shopify-section-' + id);
        if (target && source) {
          target.innerHTML = source.innerHTML;
          replaced++;
        }
      });

      // Fallback: als secties niet vervangen konden worden, pagina verversen.
      if (!replaced) window.location.reload();
    }
  }

  customElements.define('bunitta-bag-upsell', BunittaBagUpsell);
})();
